import React, { useEffect } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { useStyles } from './style';
import jMoment from 'moment-jalaali';
import {
  LoadingPage,
  PageContainer,
  TableComponents,
  SimpleDialog,
  ButtonLoading,
  PriceLabel,
} from 'components';
import { columns, generateData } from './components/Columns';
import { numberWithCommas } from '../../../../../utility/util';
import Services from '../../services/ReceivedSubscriptionsServices';
import { useParams, useLocation } from 'react-router-dom';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../../../hooks';
import { constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

export default function ReceivedSubscriptionsList(props) {
  const {
    loading,
    setLoading,
    data,
    setData,
    loadingTable,
    setloadingTable,
    open,
    setOpen,
    setLoadingBtn,
    size,
    loadingBtn,
    setSize,
    page,
    setPage,
  } = useCustomHook();

  // --HOOKS--//
  const statusPane = {
    SUBSCRIPTION_PLAN_TYPE_BLOCK: 'مسدودی',
    SUBSCRIPTION_PLAN_TYPE_CASH: 'نقدی',
    SUBSCRIPTION_PLAN_TYPE_POST_PAID: 'پس پرداخت',
  };
  const statusType = {
    SUBSCRIPTION_NOT_VERIFY: 'در انتظار تایید',
    SUBSCRIPTION_TIMEOUTED: 'منقضی شده',
    SUBSCRIPTION_CONFIRM: 'تایید شده',
    SUBSCRIPTION_EXPIRED: 'به اتمام رسیده',
    SUBSCRIPTION_REJECTED: 'رد شده',
    SUBSCRIPTION_REVOKED: 'لغو شده',
  };
  const classes = useStyles();
  const currencyText = useCurrencyUnit(false);
  const location = useLocation();
  const { id } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const planId = searchParams.get('planId');
  useEffect(() => {
    getSubscrptionDetails();
  }, []);
  const getSubscrptionDetails = () => {
    setLoading(true);
    const params = {
      offset: 0,
      size: 50,
      subscriptionId: id,
      subscriptionPlanId: planId,
    };
    Services.getSubscriptions(params)
      .then((res) => {
        setData(res.result[0]);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  // plan
  const getSubscriptionPlan = async (query) => {
    setloadingTable(true);
    try {
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
      };
      const res = await Services.getSubscriptionPlan(planId, params);
      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      setloadingTable(false);
      return d;
    } catch (error) {
      if (axios.isCancel(error)) {
        setloadingTable(true);
      } else {
        setloadingTable(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };
  const payDialog = () => {
    setOpen(true);
  };
  const onAccept = () => {
    setLoadingBtn(true);
    Services.subscriptionPayment(data.id)
      .then((res) => {
        createToast('موفق', 'پرداخت با موفقیت انجام شد', 'success');

        setOpen(false);
        setLoadingBtn(false);
      })
      .catch((error) => {
        setOpen(false);
        setLoadingBtn(false);
      });
  };
  const handleCloseDialog = () => {
    setOpen(false);
  };
  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          name="بله"
          loading={loadingBtn}
          onClick={onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  return (
    <>
      <PageContainer
        title="اطلاعات پایه"
        breadcrumbs={constBreadCrumbsTitle.SUBSCRIPTIONS_RECEIVED_WITH_ID}
        className={classes.root}
        loading={loading}
      >
        {data ? (
          <Grid container direction="row" alignItems="center" item>
            {loading ? <LoadingPage /> : null}

            <Grid item xs={12}>
              <Grid container xs={12} md={9} className={classes.info}>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>نام طرح</Typography>
                  <Typography className={classes.detailValue}>{data?.plan?.name || '-'}</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>نوع طرح</Typography>
                  <Typography className={classes.detailValue}>
                    {statusPane[data?.plan?.typeCode] || '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مبلغ</Typography>
                  <Typography className={classes.detailValue} s tyle={{ fontFamily: 'Vazir' }}>
                    <PriceLabel amount={data?.plan?.price || 0} currency={currencyText} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>تاریخ درخواست</Typography>
                  <Typography className={classes.detailValue}>
                    {data?.creationDate
                      ? jMoment(data.creationDate)?.format('dddd, jD jMMMM jYYYY') ?? '-'
                      : '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>از تاریخ </Typography>
                  <Typography className={classes.detailValue}>
                    {data?.fromDate
                      ? jMoment(data.fromDate)?.format('dddd, jD jMMMM jYYYY') ?? '-'
                      : '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>تا تاریخ </Typography>
                  <Typography className={classes.detailValue}>
                    {data?.toDate
                      ? jMoment(data.toDate)?.format('dddd, jD jMMMM jYYYY') ?? '-'
                      : '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>محدودیت مبلغ</Typography>
                  <Typography className={classes.detailValue}>
                    {data?.plan?.usageAmountLimit ? (
                      <>
                        <PriceLabel amount={data?.usedAmount || 0} />
                        {' از '}
                        <PriceLabel amount={data.plan.usageAmountLimit} currency={currencyText} />
                      </>
                    ) : (
                      <PriceLabel amount={data?.usedAmount || 0} />
                    )}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>محدودیت دفعات استفاده</Typography>
                  <Typography className={classes.detailValue}>
                    {data?.plan?.usageCountLimit ? (
                      <>
                        <PriceLabel amount={data?.usageCount || 0} />
                        {' از '}
                        <PriceLabel amount={data.plan.usageCountLimit} />
                        {' بار استفاده'}
                      </>
                    ) : (
                      <>
                        <PriceLabel amount={data?.usageCount || 0} />
                        {' بار استفاده'}
                      </>
                    )}
                  </Typography>
                </Grid>

                {}
                {}

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>وضعیت</Typography>
                  <Typography className={classes.detailValue}>
                    {statusType[data?.status]}
                  </Typography>
                </Grid>
                {data?.plan?.typeCode == 'SUBSCRIPTION_PLAN_TYPE_POST_PAID' &&
                  data?.notSettledUsedAmount > 0 && (
                    <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                      <Typography className={classes.detailTitle}>میزان کل بدهی</Typography>
                      <Typography className={classes.detailValue}>
                        {numberWithCommas(data?.notSettledUsedAmount)}
                        <a className={classes.amountPaid} onClick={payDialog}>
                          پرداخت بدهی
                        </a>
                      </Typography>
                    </Grid>
                  )}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <div style={{ textAlign: 'center', minHeight: '300px' }}>موردی یافت نشد</div>
        )}

        <SimpleDialog
          title={'پرداخت بدهی'}
          content={`آیا می‌خواهید مبلغ  ${data?.notSettledUsedAmount}  را از کیف پول خود پرداخت کنید؟`}
          open={open}
          actions={<ChangeStateActionBtn />}
        />
      </PageContainer>

      <PageContainer title="لیست محصولات" className={classes.root}>
        {currencyText && (
          <TableComponents
            data={getSubscriptionPlan}
            columns={columns(currencyText)}
            isLoading={loadingTable}
            onChange={(ps) => {
              setPage(ps?.pageNumber);
              setSize(ps?.pageSize);
              return getSubscriptionPlan(ps);
            }}
          />
        )}
      </PageContainer>
    </>
  );
}
